module.exports = {"api_url":"https://gzbags.baigers.com/gzsba"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = DEN3
// module chunks = 47